export enum GlobalMutationTypes {
  SET_MINI = 'SET_MINI',
  SET_IS_PENDO_LOADED = 'SET_IS_PENDO_LOADED',
  SET_APP_STATE = 'SET_APP_STATE',
  SET_HOME_LAYOUT = 'SET_HOME_LAYOUT',
  SET_PROJECT_LAYOUT = 'SET_PROJECT_LAYOUT',
  SET_TOGGLE_PROJECT_DRAWER = 'SET_TOGGLE_PROJECT_DRAWER',
  SET_NAVIGATION_DRAWER_PROFILE = 'SET_NAVIGATION_DRAWER_PROFILE',
  SET_BADGE_PROFILE_VISIBLE = 'SET_BADGE_PROFILE_VISIBLE',
  SET_ROUTER_HISTORY = 'SET_ROUTER_HISTORY',
}
